"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_GROUP = exports.TABLE = exports.REF = exports.ENUM = exports.DEFAULT_SCHEMA_NAME = void 0;
var DEFAULT_SCHEMA_NAME = 'public';
exports.DEFAULT_SCHEMA_NAME = DEFAULT_SCHEMA_NAME;
var TABLE = 'table';
exports.TABLE = TABLE;
var ENUM = 'enum';
exports.ENUM = ENUM;
var REF = 'ref';
exports.REF = REF;
var TABLE_GROUP = 'table_group';
exports.TABLE_GROUP = TABLE_GROUP;